<template>
    <div>
      <div class="inner-header">
        <nav class="navbar fixed-top animate__animated animate__slideInRight">
          <a  @click="$router.go(-1)" class="back-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
                 <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                    <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                    <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
                 </g>
              </svg>
           </a>
           <a href="javascript:void(0);" class="link-title">Daily Stand Up</a>
        </nav>
      </div>
  
      <div class="inner-page animate__animated animate__slideInRight">
          <div class="container-fluid">
              <div class="row">
                  <!-- Enquiry Card -->
                  <div class="col-12">
                      <div class="card details-card">
                          <div class="card-header">
                              <div class="row">
                                  <div class="col-12" v-if="MeetingDetails.field_executive">
                                      <span class="lead-title">{{MeetingDetails.field_executive}}</span>
                                  </div>
                              </div>
                          </div>
                          <div class="card-body">
                              <div class="row">
                                  <div class="col-6" v-if="MeetingDetails.stand_up_type">
                                      <span class="enq-title ">Standup Type</span>
                                      <span class="enq-details">{{MeetingDetails.stand_up_type}}</span>
                                  </div>
                                  <div class="col-6" v-if="MeetingDetails.created_at">
                                      <span class="enq-title ">Initiated At</span>
                                      <span class="enq-details">{{MeetingDetails.created_at}}</span>
                                  </div>
                                  <div class="col-6" v-if="MeetingDetails.todays_meeting_target">
                                      <span class="enq-title">Today's Meeting Target</span>
                                      <span class="enq-details">{{MeetingDetails.todays_meeting_target}}</span>
                                  </div>
                                  <div class="col-6 cursor-p" @click="goToMyMeetings()" v-if="MeetingDetails.todays_meeting_target">
                                      <span class="enq-title hyper-link">Today's Target Done</span>
                                      <span class="enq-details hyper-link">{{MeetingDetails.todays_meeting_done}}</span>
                                  </div>
                                  <div class="col-6" v-if="MeetingDetails.enquiry_sourcing_target">
                                      <span class="enq-title">Enquiry Sourcing Target</span>
                                      <span class="enq-details">{{MeetingDetails.enquiry_sourcing_target}}</span>
                                  </div>
                                  <div class="col-6" v-if="MeetingDetails.enquiry_sourcing_target" @click="goToEnquiries">
                                      <span class="enq-title hyper-link">Enquiry Target</span>
                                      <span class="enq-details hyper-link">{{MeetingDetails.actual_enq_sourced}}</span>
                                  </div>
                                  <div class="col-6" v-if="MeetingDetails.sign_in_at">
                                      <span class="enq-title ">Office Sign In Time</span>
                                      <span class="enq-details">{{MeetingDetails.sign_in_at}}</span>
                                  </div>
                                  <div class="col-6" v-if="MeetingDetails.sign_off_at">
                                      <span class="enq-title ">Office Sign Out Time</span>
                                      <span class="enq-details">{{MeetingDetails.sign_off_at}}</span>
                                  </div>
                                  <div class="col-6" v-if="MeetingDetails.outdoor_start_time">
                                      <span class="enq-title ">Outdoor Start Time</span>
                                      <span class="enq-details">{{MeetingDetails.outdoor_start_time}}</span>
                                  </div>
                                  <div class="col-6" v-if="MeetingDetails.outdoor_end_time">
                                      <span class="enq-title ">Outdoor End Time</span>
                                      <span class="enq-details">{{MeetingDetails.outdoor_end_time}}</span>
                                  </div>
                                    <div class="col-6" v-if="MeetingDetails.comment">
                                      <span class="enq-title">Comment</span>
                                      <read-more class="read-more read-more-custom" more-str="show more"  :text="MeetingDetails.comment" link="#" less-str="show less" :max-chars="50"></read-more>

                                      <!-- <span class="enq-details">{{MeetingDetails.comment}}</span> -->
                                  </div>
                                  
                                <!-- <div class="col-6" v-if="!isFromMyMeetings">
                                  <span class="enq-title">App Engagement</span>
                                  <span class="enq-details">{{MeetingDetails.app_engagement ? 'Yes' : 'No'}}</span>
                                </div> -->
                              </div>
                              <div class="row mt-3">
                                <div class="col-12" v-if="MeetingDetails.no_app_engagement_comments && !MeetingDetails.app_engagement">
                                  <span class="enq-title">Reason of No App Engagement</span>
                                  <span class="enq-details">{{MeetingDetails.no_app_engagement_comments}}</span>
                                </div>
                              </div>
                              <div class="row">
                                <!-- <div class="col-12" v-if="MeetingDetails.location">
                                  <span class="enq-title">Meeting Location</span>
                                  <span class="enq-details">{{MeetingDetails.location}}</span>
                                </div> -->
                                <div class="col-6" v-if="MeetingDetails.location">
                                    <span class="enq-title">Sign-in Meeting location</span>
                                    <read-more more-str="show more" class="read-more read-more-custom" :text="MeetingDetails.location" link="#" less-str="show less" :max-chars="50"></read-more>
                                </div>
                                <div class="col-6" v-if="MeetingDetails.signing_off_location && MeetingDetails.signing_off_selfie_photo_url">
                                    <span class="enq-title">Sign-off Meeting location</span>
                                    <read-more more-str="show more" class="read-more read-more-custom" :text="MeetingDetails.signing_off_location" link="#" less-str="show less" :max-chars="50"></read-more>
                                </div>
                                
                                <div class="col-6" v-if="MeetingDetails.selfie_photo_url">
                                  <span class="label label-tag"></span>
                                  <!-- <button class="btn btn-danger ml-3" v-if="isDeleteAvailable" @click="deleteRecord($event, item)">Delete</button> -->
                                  <b-button v-b-modal.modal-1>Sign-in Selfie</b-button>
                                  <!-- <b-button ref="delete-modal" hide-footer title="Using Component Methods" @click="deleteRecord">Delete</b-button> -->
                                </div>
                                <div class="col-6" v-if="MeetingDetails.signing_off_selfie_photo_url">
                                  <span class="label label-tag"></span>
                                  <!-- <button class="btn btn-danger ml-3" v-if="isDeleteAvailable" @click="deleteRecord($event, item)">Delete</button> -->
                                  <b-button v-b-modal.modal-2>Sign-off Selfie</b-button>
                                  <!-- <b-button ref="delete-modal" hide-footer title="Using Component Methods" @click="deleteRecord">Delete</b-button> -->
                                </div>
                              </div>
                          </div>
                        </div>
                        <!-- Modal -->
                  <div>
            </div>
              <div class="card-btn">
                <div class="row">
                  <div class="col-12 mb-3">
                    <router-link v-if="MeetingDetails.can_edit_daily_stand_up" class="btn btn-secondary btn-block" :to="{ name: 'EditDailyMeeting', params: { id: MeetingDetails.id }}">
                      <span class="center-fix">
                        <img src="@/assets/edit-orange.svg" alt="" class="mr-1\" />Edit
                      </span>
                    </router-link>
                    <span class="center-fix btn btn-white btn-block disabled" v-else>
                      <img src="@/assets/edit-orange.svg" alt="" class="mr-1\" />Edit
                    </span>
                  </div>
                </div>
              </div>

              <b-modal ref="my-modal" dialog-class="daily-standup-details-modal" id="modal-1" class="modal" hide-footer>
                <div>
                  <img :src="MeetingDetails.selfie_photo_url" class="selfie-photo">
                </div>
              </b-modal>
              <b-modal ref="my-modal" dialog-class="daily-standup-details-modal" id="modal-2" class="daily-standup-details-modal" hide-footer>
                <div>
                  <img :src="MeetingDetails.signing_off_selfie_photo_url" class="selfie-photo">
                </div>
              </b-modal>
            </div>
          </div>
      </div>
  </div>
  </div>
  </template>
  <script>
  export default {
    name: 'DailyStandUpDetails',
    data() {
      return {
        AllProjectsOfThisMeetings: [],
        MeetingDetails: {},
        queryP: {},
        showSelfieImage:false,
        isFromMyMeetings: false,
      }
    },
    created () {
      this.isFromMyMeetings = JSON.parse(sessionStorage.getItem("isFromMyMeetings"));
      this.FetchMeetingDetails()
    },
    methods: {
      goToMyMeetings() {
        sessionStorage.setItem('meetingDetails', JSON.stringify(this.MeetingDetails))
        this.$router.push('/Meeting'); 
      },
      goToEnquiries() {
        sessionStorage.setItem('meetingDetails', JSON.stringify(this.MeetingDetails))
        this.$router.push('/');
      },
      FetchMeetingDetails() {
        this.queryP['id'] = this.$route.params.id;
        if(!this.isFromMyMeetings) {
          this.$axios.get(`daily_stand_ups/${this.queryP.id}/daily_stand_up_detail`).then((res) => {
            this.MeetingDetails =  res.data.daily_stand_up;
          });
        } else {
          this.$axios.get(`/enquiries/client_meetings/${this.queryP.id}/client_meeting_detail?id=${this.queryP.id}`).then((res) => {
            this.MeetingDetails = res.data.client_meeting;
          });
        }
      },
      toggleSelfieImage(){
          this.showSelfieImage = !this.showSelfieImage;
      }
    }
  }
  </script>
  <style scoped>
    .selfie-photo {
      width: 100%;
    }
      .inner-page{
          margin-top: 60px;
      }
      .selfie-image{
          display: flex;
          align-items: center;
          justify-content: center;
      }
      .selfie-toggle{
          padding-left: 0;
      }
      .selfie-image-background{
          background: url('~@/assets/no-avatar.svg') no-repeat 0px center  #fff;
          min-height: 100px;
          min-width: 100px;
      }
      .hyper-link {
        color: blue !important;
        cursor: pointer;
      }
      .read-more{
        font-size: 14px;
        line-height: 1.4;
      }
      .read-more p {
        margin-bottom: 5px;
      }
      .modal{
        top: 30%;
      }
  </style>